var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canAccessGit)?_c('span',{staticClass:"owal git info",on:{"dblclick":function($event){_vm.showFull = !_vm.showFull}}},[_vm._v("\n  "+_vm._s(this.gitInfo)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }